import { Component, HostListener, Injector, OnInit, inject, viewChild } from '@angular/core';
import { JkdaterangeComponent, JkComboboxComponent, } from 'jk-service';
import { JkBaseOption, jkLib, OpenWinLoadOption, } from 'jk-service';
import { JkLineChartComponent } from '../components/line-chart/line-chart.component';
import { StockService } from '../services/stock.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { JkFullscreenService } from './fullscreen.service';
import { MaterialModule } from 'jk-service';
import { jkBaseForm } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, JkbtneditComponent } from 'jk-advcom';
import { StockView01Component } from '../stock-view01/stock-view01.component';
import { StockData } from '../services/stockBase';

class PageOption extends JkBaseOption {
  // ###
}

class FilterOption extends JkBaseOption {
  // ###
  marketNo = '0';
  date1: string = '';
  date2: string = '';
  frequency: string = '日線'; // 資料頻率
  stockNo: string = '';
  orderBy: string = 'ORDER BY LG001,LG002,LG003,LG004';
}


@Component({
  selector: 'app-stkpq13',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, JkLineChartComponent, StockView01Component,
    AdvComModule,
  ],
  templateUrl: './stkpq13.component.html',
  styleUrl: './stkpq13.component.css'
})
export class Stkpq13Component extends jkBaseForm implements OnInit { // jkQueryComponent
  override _programId = 'stkpq13'; // ###
  itemList: any[] = [];
  pageOpt: PageOption = new PageOption(this.programId + '_page'); //###
  filterOpt: FilterOption = new FilterOption(this.programId); //###
  dataSource = new MatTableDataSource<any>(this.itemList);//any[] = [];
  displayedColumns: string[] = ['id', 'chart']; // ['id', 'name', 'chart'];

  readonly paginator = viewChild.required<MatPaginator>('paginator');

  readonly stkme001 = viewChild.required<JkbtneditComponent>('stkme001');

  readonly stklg001 = viewChild.required<JkdaterangeComponent>('stklg001');
  readonly stkma019 = viewChild.required<JkComboboxComponent>('stkma019');
  readonly stklg002 = viewChild.required<JkComboboxComponent>('stklg002');
  readonly stklg004 = viewChild.required<JkbtneditComponent>('stklg004');
  readonly cboOrder = viewChild.required<JkComboboxComponent>('orderBy');
  public stockSrv: StockService = new StockService();
  fullscreenService: JkFullscreenService = new JkFullscreenService();
  constructor() {
    const injector = inject(Injector);
    super(injector);
    this.setFormOpt2(); //###
    this.onBackClick.bind(this);
    this.logMessage = '無錯誤訊息';
    this.fullscreenService.toggleFullscreen(document.documentElement);
  }

  override ngOnInit() {
    super.ngOnInit();
    /*this.filterOpt = new FilterOption(this.programId); //###
    this.filterOpt.load(); //###
    this.pageOpt = new PageOption(this.programId + '_page'); //###
    this.pageOpt.load(); //###*/
  }
  date1: string = jkLib.countDate(jkLib.nowDate(), 'D', -120);
  date2: string = jkLib.nowDate();

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.dataSource.paginator = this.paginator();
    setTimeout(() => {
      //this.stklg001.valueA = jkLib.countDate(jkLib.nowDate(), 'D', -120);
      //this.stklg001.valueB = jkLib.nowDate();
      this.stkme001().value = '000'; // 000	追蹤全部
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);
    //this.stkma001List = await jkOpenWin.doOpenWin<idNameItem[]>('S','#STKMA001','V01',[]);

    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
  }
  ngOnExit() { }
  tableVisible: boolean = false;
  async doQuery(): Promise<boolean> {
    //await this.init(this.programId,'S01','S',['LG001','LG002','LG003','LG004'],[]);
    this.masterTabGroupIndex = 1;
    this.tableVisible = false;
    let where = '';
    where = this.stkme001().addWhere(where, "MF001");
    let opt: OpenWinLoadOption = { mainTable: 'STKMF', type: 'S', item: 'S02', params: [], where: where, order: ' ORDER BY MF002 ', list: this.itemList };
    this.orm.doOpenwin(opt).subscribe((data: any) => {
      this.itemList = data.obj;
      this.dataSource.data = this.itemList;
      this.updateStockData(this.dataSource.data);
      this.tableVisible = true;
    });


    return true;
  }

  toggleFullscreen() {
    this.fullscreenService.toggleFullscreen(document.documentElement);
  }
  onBackClick() {
    if (this.fullscreenService)
      this.fullscreenService.toggleFullscreen(document.documentElement);
  };

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    //if((event.ctrlKey) && (event.key === 'PageUp')) {
    const paginator = this.paginator();
    if ((event.altKey) && (event.key === 'PageUp')) {
      if (paginator.hasPreviousPage())
        paginator.previousPage();
      this.updateStockData(this.dataSource.filteredData);
    }
    if (event.altKey && (event.key === 'PageDown')) {
      if (paginator.hasNextPage())
        paginator.nextPage();
      this.updateStockData(this.dataSource.filteredData);
    }
  }
  async updateStockData(data: any[]) {
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      let stockData: StockData = new StockData();
      let where = ` AND LG004='${item.id}' AND (LG001 BETWEEN '${this.date1}' AND '${this.date2}') AND LG002='${this.stklg002().value}' `;
      /*try {
        this.stklg004.value = item.id; //addwhere value 會是舊值
        where = this.stklg004.addWhere(where, 'LG004');
  
        where = this.stklg001.addWhere(where, 'LG001');
        where = this.stklg002.addWhere(where, 'LG002');
      } catch (error:any) {
        alert('doQuery:' + error.message);
        return;
      }*/
      /*this.stklgGrid.maintable = 'STKLG';
      this.stklgGrid.item = 'V02';
      this.stklgGrid.type = 'S';
      this.stklgGrid.where = where;*/
      /*orm.getopenwin('STKLG','V02','S').subscribe((data) => {
      });*/
      let sqlSelect = `SELECT TOP 1 LG001 date1,
        FORMAT(CONVERT(datetime, LG001, 112), 'yyyy/MM/dd') AS FormattedDate,
        LG003 time1,
        STUFF(RIGHT('0000' + LG003, 4), 3, 0, char(58)) AS FormattedTime,
      CONVERT(datetime,LG001+' '+STUFF(RIGHT('0000' + LG003, 4), 3, 0, char(58))) AS datetime1,
      SUBSTRING(LG001,5,8)+(CASE WHEN SUBSTRING(LG002,1,1)='0' THEN '-'+LG003 ELSE '' END) as [X],
        LG004 as stockno,MA002 as stockName,LG005 as qty,
      LG007 as [open],LG008 as high,LG009 as low,LG010 as [close],LG011 as yClose,
      LG012 updateTime,LG013 as analysis,LG014 as UBT,LG015 as LBT,LG016 as BBIndex,LG017 as AvgBT,
      LG018    BBandBW,LG019 as macd,LG020 as dif,LG021 as osc,LG022 AS updownRate,LG023 AS pricePercent,
      LG024 as updown,LG025 as sma5,LG026 as sma10,LG027 as sma20,LG028 as sma60,
      LG029 as   K,LG030 as D,LG031 AS buyPoint,LG032 weekPercent,LG033 as monthPercent,LG034 seasonPercent,
      LG035 qtyPercent,LG036 as sma5Dir,LG037 sma10Dir,LG038 sma20Dir,LG039 sma60Dir,LG040 state1,LG041 KLineStyle,
      LG042 newPrice,LG043 bias5,LG044 bias10,LG045 bias20,LG046 bias60,LG047 ma5,LG048 ma10,
      0 as yQty,LG010 as avg,0 sma120,0 as sma240,0 as isSmaUp3,0 isSmaUp4,0 as KSize,0 KHighShadow,0KLowShadow,0 UBdir,0 LBdir
      FROM STKLG
      LEFT JOIN STKMA ON MA001=LG004
      /*WHERE*/ WHERE 1=1 ${where}
      ORDER BY LG001 DESC,LG002,LG003,LG004
      `;
      let r = await this.orm.simpleSqlPromise(this.login.host, sqlSelect, this.ret);
      if (r.length > 0) {
        stockData.importStklgV02(r[0]);
        item.stockData = stockData;
      }
      //console.log(JSON.stringify(item));

    }

  }
  // ### [以上是必要的]================================

}
